import { render } from "./ProductListCom.vue?vue&type=template&id=5feebc7f&scoped=true"
import script from "./ProductListCom.vue?vue&type=script&lang=js"
export * from "./ProductListCom.vue?vue&type=script&lang=js"

import "./ProductListCom.vue?vue&type=style&index=0&id=5feebc7f&scoped=true&lang=css"

import exportComponent from "E:\\project_copy_from_e\\项目\\后台\\cost_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5feebc7f"]])

export default __exports__